"use client";

import Script from "next/script";
import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { trackView } from "@/app/actions";
import { isAdminPath } from "@/lib/admin-path";

const GA_MEASUREMENT_ID = "G-MDJVNRB45V";
const CLARITY_PROJECT_ID = "uuqepee30l";

export default function Analytics() {
    const pathname = usePathname();
    const isAdmin = isAdminPath(pathname);

    // Internal page view tracking (for admin analytics) on every public page. /admin is the owner's own back office:
    // no server action is sent for it (trackView would ignore it anyway).
    useEffect(() => {
        if (pathname && !isAdminPath(pathname)) {
            trackView(pathname).catch(err => console.error("Analytics error:", err));
        }
    }, [pathname]);

    // Don't load Google Analytics or Clarity on admin pages
    if (isAdmin) {
        return null;
    }

    return (
        <>
            {/* GA loads after the page has loaded (lazyOnload) so gtag (~180 KB, two long main-thread tasks) no longer
                competes with the page itself (PageSpeed 2026-10-27). dataLayer/gtag are set up inline right away, so the
                page view is queued and sent once gtag.js arrives. */}
            <Script id="ga-init" strategy="afterInteractive">
                {`window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${GA_MEASUREMENT_ID}');`}
            </Script>
            <Script src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`} strategy="lazyOnload" />
            <Script
                id="microsoft-clarity"
                strategy="lazyOnload"
                dangerouslySetInnerHTML={{
                    __html: `
                        (function(c,l,a,r,i,t,y){
                            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
                        })(window, document, "clarity", "script", "${CLARITY_PROJECT_ID}");
                    `
                }}
            />
        </>
    );
}
